import React from 'react';
import styles from './styles/CVEFormulaLabel.module.css';

const CVEFormulaAnnualThreeSixty = () => (
	<>
		<span className={styles.division}>
			<span>
				<span>expense</span>
				<span className={styles.times} />
				12
			</span>
			<span>360</span>
		</span>
		<span className={styles.times} />
		<span>hire days</span>
	</>
);

export default CVEFormulaAnnualThreeSixty;
